








































































import { Vue, Component } from 'vue-property-decorator'
import { getThumbUrl } from '@/utils/thumbnail'

@Component
export default class HomePhotos extends Vue {
    images: string[] = []
    uploading = false
    saving = false
    loading = false
    saveError = ''
    successMsg = ''
    getThumbUrl = getThumbUrl

    async created () {
        this.loading = true
        try {
            const imgs: string[] = await this.$store.dispatch('homePhotos')
            this.images = Array.isArray(imgs) ? [...imgs] : []
        } catch (e) {
            // If loading fails, start with empty list
        } finally {
            this.loading = false
        }
    }

    async onFilesChange (event: Event) {
        const input = event.target as HTMLInputElement
        if (!input.files || input.files.length === 0) return

        const files = Array.from(input.files)
        this.uploading = true
        this.saveError = ''
        this.successMsg = ''
        try {
            const urls: string[] = await this.$store.dispatch('uploadApartmentPhotos', files)
            if (Array.isArray(urls)) {
                this.images = [...this.images, ...urls]
            }
        } catch (e) {
            this.saveError = '사진 업로드 중 오류가 발생했습니다.'
        } finally {
            this.uploading = false
            if (this.$refs.fileInput) {
                (this.$refs.fileInput as HTMLInputElement).value = ''
            }
        }
    }

    removeImage (idx: number) {
        this.images.splice(idx, 1)
    }

    moveImage (from: number, to: number) {
        const arr = [...this.images]
        const item = arr.splice(from, 1)[0]
        arr.splice(to, 0, item)
        this.images = arr
    }

    async save () {
        if (this.uploading || this.saving) return
        this.saveError = ''
        this.successMsg = ''
        this.saving = true
        try {
            await this.$store.dispatch('setHomePhotos', this.images)
            this.successMsg = '메인홈에 반영됐습니다.'
        } catch (e) {
            const err = e as any
            const msg = err?.response?.data?.message || err?.message || '저장 중 오류가 발생했습니다.'
            this.saveError = msg
        } finally {
            this.saving = false
        }
    }
}
